import { render, staticRenderFns } from "./AddEndpointDialog.vue?vue&type=template&id=1f980c78&scoped=true&"
import script from "./AddEndpointDialog.vue?vue&type=script&lang=ts&"
export * from "./AddEndpointDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddEndpointDialog.vue?vue&type=style&index=0&id=1f980c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f980c78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
